// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import { groupBy } from '../../utlis';
import { CURRENT_DATE } from '../../constants';
import '../../css/permission.css';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UserPermission = () => {
  const [report, setReport] = useState([]);
  const { t } = useTranslation();
  const token = getToken();
  const userId = decodeToken(token, 'id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [message, setMessage] = useState([]);
  const [executionTime, setExecutionTime] = useState(null);

  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [permissions, setPermissions] = useState([]);
  // console.log("route:",route)

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/permission%2F${route}`;
    // console.log('url:', url);
    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        setLink(response.data.link);
        //console.log('link:', response.data.link);
        setInputs(response.data.inputs);
        // console.log('inputs:', response.data.inputs);

        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (
            input.type === 'dropdown' ||
            input.type === 'load_dropdown'
          ) {
            initialState[input.name] = '%';
          } else {
            initialState[input.name] = input.value.trim();
          }
        });

        //add default values for user_id and date
        initialState['user_id'] = userId;
        //  initialState['date'] = CURRENT_DATE;
        //Set all initial input values to the state values
        setValues(initialState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchForm();

    // setLinks(groupBy(report,'category'));
  }, [route]);

  //console.log('report:', report);
  const [checkedItems, setCheckedItems] = useState({});

  const handleSubCategoryChange = async (
    subCategory,
    subCategoryItems,
    event
  ) => {
    const isChecked = event.target.checked;

    setCheckedItems((prevState) => {
      const newState = { ...prevState };

      subCategoryItems.forEach(async (item) => {
        console.log(`items in ${subCategory} : `, item);
        newState[item.link_id] = isChecked;
        //  await handleCheckboxChange(item.link_id, item.id, item.action, event);
      });

      return newState;
    });
  };

  const handleCheckboxChange = async (link_id, permissionID, action, event) => {
    let values2;

    if (route === 'student') {
      values2 = {
        link_id: link_id,
        grant_class_id: values.class_id, // replace key
        action: action,
        user_id: userId,
        date: CURRENT_DATE,
      };
    } else if (route === 'permissionByStudent') {
      values2 = {
        link_id: link_id,
        grant_student_id: values.student_id, // replace key
        action: action,
        user_id: userId,
        date: CURRENT_DATE,
      };
    } else {
      values2 = {
        grant_user_id: values.grant_user_id,
        user_id: userId,
        action: action,
        date: CURRENT_DATE,
        link_id: link_id,
      };
    }

    //alert( values2.type, values2.link_id);
    console.log('vv:', values2);

    let url = '';

    if (event.target.checked) {
      // --- Add permission ---
      url =
        route === 'student'
          ? `${API_URL}/${ENDPOINTS.SYS}/create/Create-Student-Permission`
          : route === 'permissionByStudent'
            ? `${API_URL}/${ENDPOINTS.SYS}/create/Create-Permission-By-Student`
            : `${API_URL}/${ENDPOINTS.SYS}/create/create-user-permission`;

      try {
        const response = await axios.post(url, values2, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        console.log('Response (insert):', response.data);
      } catch (err) {
        console.error('Error (insert):', err);
      }
    } else {
      // --- Remove permission ---
      url =
        route === 'student'
          ? `${API_URL}/${ENDPOINTS.SYS}/create/Delete-Student-Permission`
          : route === 'permissionByStudent'
            ? `${API_URL}/${ENDPOINTS.SYS}/create/Delete-By-Student-Permission`
            : `${API_URL}/${ENDPOINTS.SYS}/create/delete-user-permission`;

      try {
        const response = await axios.post(url, values2, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        console.log('Response (delete):', response.data);
      } catch (err) {
        console.error('Error (delete):', err);
      }
    }
  };
  // console.log('links:', links);
  return (
    <>
      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
        setPermissions={setPermissions}
      />

      <div className="container">
        <div className="row">
          {report &&
            Object.keys(groupBy(report, 'category')).map((category) => {
              const categorizedData = groupBy(
                groupBy(report, 'category')[category],
                'sub_category'
              );

              return (
                <div key={category} className="col-4">
                  <div className="category-container">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      disabled
                    />
                    <label className="form-check-label">
                      &nbsp; {t(category)}
                    </label>

                    <ul className="nested-list">
                      {Object.keys(categorizedData).map((subCategory) => {
                        const validSubCategory =
                          subCategory && subCategory.trim() !== ''
                            ? subCategory
                            : category; // Handle None or empty sub_category

                        return (
                          <li
                            key={validSubCategory}
                            className="subcategory-container"
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={categorizedData[subCategory].every(
                                (item) => checkedItems[item.link_id]
                              )}
                              onChange={(event) =>
                                handleSubCategoryChange(
                                  subCategory,
                                  categorizedData[subCategory],
                                  event
                                )
                              }
                              disabled
                            />
                            <label className="form-check-label">
                              &nbsp; {t(validSubCategory)}
                            </label>
                            <ul className="nested-sub-list">
                              {categorizedData[subCategory].map((item) => {
                                // Extract edit and delete permissions from the has_edit_delete value
                                // const hasCreate = item.has_edit_delete?.split(',')[0];
                                const hasEdit =
                                  item.has_edit_delete?.split(',')[0];

                                const hasDelete =
                                  item.has_edit_delete?.split(',')[1];

                                const hasPerEdit =
                                  hasEdit?.split(':')[1] === '1' ? true : false;
                                const hasPerDelete =
                                  hasDelete?.split(':')[1] === '1'
                                    ? true
                                    : false;

                                return (
                                  <li
                                    key={`${item.action}-${item.link_id}`}
                                    className="form-check"
                                  >
                                    <input
                                      className={`form-check-input ${category.replace(/\s/g, '')}`}
                                      type="checkbox"
                                      defaultChecked={item.is_checked}
                                      // defaultChecked={
                                      //   checkedItems[item.link_id] || false
                                      // }
                                      link={item.link_id}
                                      id={item.id}
                                      action={item.action}
                                      onChange={(event) =>
                                        handleCheckboxChange(
                                          item.link_id,
                                          item.id,
                                          item.action,
                                          event
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`checkbox-${item.id}`}
                                    >
                                      {t(item.link)}
                                    </label>

                                    {/* Check if the item has either edit or delete permission */}
                                    {(hasEdit || hasDelete) && (
                                      <ul className="sub-list">
                                        {hasEdit.split(':')[0] === '1' && (
                                          <li className="form-check">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={`edit-${item.id}`}
                                              defaultChecked={hasPerEdit}
                                              onChange={(event) =>
                                                handleCheckboxChange(
                                                  item.link_id,
                                                  item.id,
                                                  'edit',
                                                  event
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`edit-${item.id}`}
                                            >
                                              Edit {t(item.link)}
                                            </label>
                                          </li>
                                        )}
                                        {hasDelete.split(':')[0] === '1' && (
                                          <li className="form-check">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={`delete-${item.id}`}
                                              defaultChecked={hasPerDelete}
                                              onChange={(event) =>
                                                handleCheckboxChange(
                                                  item.link_id,
                                                  item.id,
                                                  'delete',
                                                  event
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`delete-${item.id}`}
                                            >
                                              Delete {t(item.link)}
                                            </label>
                                          </li>
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default UserPermission;
